import { ButtonPermissionMap } from '../../constant/ButtonPermission'
export default [
  {
    name: 'home',
    path: 'home',
    component: () => import(/* webpackChunkName: "home" */ './index.vue')
  },
  {
    name: 'todo',
    path: '/todo',
    component: () => import(/* webpackChunkName: "todo" */ './Todo/Todo.vue')
  },
  {
    name: 'profile',
    path: 'profile',
    meta: {
      permission: ButtonPermissionMap.MyInfrormation
    },
    component: () => import(/* webpackChunkName: "profile" */ './profile.vue')
  },
  {
    name: 'changePassword',
    path: 'changePassword',
    meta: {
      permission: ButtonPermissionMap.ChangePassword
    },
    component: () =>
      import(
        /* webpackChunkName: "password" */ '@/projects/teller/views/MyInformation/ChangePassword.vue'
      )
  }
]
